import React, { createContext, useContext, useEffect, useState } from 'react';
import { 
  THEMES, 
  themeConfigs, 
  getCurrentTheme, 
  initializeTheme 
} from './index';

const ThemeContext = createContext({
  currentTheme: THEMES.DEFAULT,
  themeConfig: themeConfigs[THEMES.DEFAULT],
  availableThemes: THEMES,
});

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [currentTheme, setCurrentTheme] = useState(() => {
    return getCurrentTheme();
  });

  useEffect(() => {
    // Initialize theme on mount
    const initialTheme = initializeTheme();
    setCurrentTheme(initialTheme);
  }, []);

  const value = {
    currentTheme,
    themeConfig: themeConfigs[currentTheme],
    availableThemes: THEMES,
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;
